module.exports = __webpack_public_path__ + "static/media/celular.78481534.png";